
define('ldsh!modules/form_editor/templates/inline_toolbar', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-item-toolbar">\n  <b class="ed-c-btn ed-c-btn-default js-duplicate" title="Duplicar"\n    data-i18n="[title]formEditor.toolbar.duplicateButton"><span class="ed-icon ed-icon-duplicate"></span></b>\n  <b class="ed-c-btn ed-c-btn-default js-move-down" title="Bajar"\n    data-i18n="[title]formEditor.toolbar.moveDownButton"><span class="ed-icon ed-icon-arrow-down"></span></b>\n  <b class="ed-c-btn ed-c-btn-default js-move-up" title="Subir" data-i18n="[title]formEditor.toolbar.moveUpButton"><span\n      class="ed-icon ed-icon-arrow-up"></span></b>\n  <b class="ed-c-btn ed-c-btn-default js-remove" title="Eliminar"\n    data-i18n="[title]formEditor.toolbar.deleteButton"><span class="ed-icon ed-icon-trashcan"></span></b>\n</div>';

}
return __p
};});

